// Shared by the floating thread and P331. Native callbacks retain authorization.
(function () {
  'use strict';
  function init() {
    if (!window.lx || !lx.msg || lx.msg.lpThreadReady || String(lx.msg.pg) === '101') { return; }
    lx.msg.lpThreadReady = true;
    var hr = /^hr/i.test(document.documentElement.lang);
    var text = hr ? {
      write:'Napišite poruku', send:'Pošalji', sending:'Slanje…',
      failed:'Poruka nije potvrđena. Nacrt je sačuvan. Provjerite razgovor prije ponovnog slanja.',
      offline:'Nema internetske veze. Nacrt je sačuvan.', emoji:'Dodaj emotikon',
      close:'Zatvori razgovor', minimize:'Smanji razgovor', maximize:'Proširi razgovor',
      more:'Opcije razgovora', status:'Uredi svoj status', history:'Poruke',
      back:'Razgovori', search:'Pretraži razgovore'
    } : {
      write:'Write a message', send:'Send', sending:'Sending…',
      failed:'Message not confirmed. Your draft is saved. Check the conversation before sending again.',
      offline:'You are offline. Your draft is saved.', emoji:'Add emoji',
      close:'Close chat', minimize:'Minimize chat', maximize:'Expand chat',
      more:'Conversation options', status:'Edit your status', history:'Messages',
      back:'Conversations', search:'Search conversations'
    };
    function accessible(control, label) {
      if (!control) { return; }
      control.setAttribute('aria-label', label); control.title = label;
      if (!control.matches('button, a, input, textarea')) {
        control.setAttribute('role', 'button'); control.tabIndex = 0;
        if (!control.dataset.lpKey) {
          control.dataset.lpKey = 'true';
          control.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); control.click(); }
          });
        }
      }
    }
    function decorate(slot) {
      slot.setAttribute('role', 'region');
      var subject = slot.querySelector(':scope > .body > .hdr > .subject');
      if (subject) { subject.id = slot.id + '-subject'; slot.setAttribute('aria-labelledby', subject.id); }
      var field = slot.querySelector('textarea');
      if (field) { field.setAttribute('aria-label', text.write); field.placeholder = text.write; }
      ['close', 'minimize', 'maximize'].forEach(function (name) { accessible(slot.querySelector('.actions .' + name), text[name]); });
      accessible(slot.querySelector('.actions .t-Button--dropdown'), text.more);
      accessible(slot.querySelector('.chatStsYou a'), text.status);
      var emoji = slot.querySelector('.emoji-button');
      if (emoji && !emoji.dataset.lpEmoji) {
        emoji.dataset.lpEmoji = 'true'; emoji.innerHTML = '<span class="far fawe-smile" aria-hidden="true"></span>';
        accessible(emoji, text.emoji);
      }
      var send = slot.querySelector('.chatForm .t-Button--primary');
      slot.querySelectorAll('.chatForm .controls .t-Button').forEach(function (control) {
        if (!control.classList.contains('emoji-button')) { accessible(control, control.textContent.trim()); }
      });
      if (send) {
        send.classList.add('lp-chat-send'); accessible(send, text.send);
        var label = send.querySelector('.t-Button-label'); if (label) { label.textContent = text.send; }
      }
      var thread = slot.querySelector(':scope > .body > .cont');
      if (thread) { thread.setAttribute('role', 'log'); thread.setAttribute('aria-label', text.history); thread.setAttribute('aria-relevant', 'additions'); }
      if (String(lx.msg.pg) === '331') {
        document.querySelectorAll('.lxMsgList .msgListRow').forEach(function (row) {
          var selected = row.id === 'Msg' + slot.dataset.id;
          row.classList.toggle('lp-chat-current', selected);
          if (selected) { row.setAttribute('aria-current', 'true'); } else { row.removeAttribute('aria-current'); }
        });
      }
    }
    var nativeOpen = lx.msg.chatOpen, opening = null;
    lx.msg.chatOpen = function (id, full) {
      if (!full && String(lx.msg.pg) !== '331') {
        opening = Number(id); lx.msg.msgPageTime = null;
      }
      return nativeOpen.apply(this, arguments);
    };
    var nativeRender = lx.msg.chatRender;
    lx.msg.chatRender = function () {
      var result = nativeRender.apply(this, arguments);
      var slot = document.getElementById('chat' + Number(arguments[0].id));
      if (slot) {
        decorate(slot);
        if (opening === Number(arguments[0].id) && !lx.msg.full) {
          var dock = document.getElementById('chatDock');
          if (dock) { dock.style.removeProperty('display'); }
          opening = null;
        }
      }
      return result;
    };
    document.querySelectorAll('#chatDock .chatSlot').forEach(decorate);

    // One timer, with the native in-flight guard. No background/offline requests.
    var timer, activeUntil = 0;
    var nativeCheck = lx.msg.chatCheck;
    function delay() { var age = activeUntil - Date.now(); return age > 60000 ? 2000 : age > 0 ? 5000 : 30000; }
    function schedule(ms) { clearTimeout(timer); timer = setTimeout(tick, ms); }
    function tick() {
      if (!document.hidden && navigator.onLine !== false) { lx.msg.chatCheck(); }
      schedule(delay());
    }
    lx.msg.chatCheck = function () {
      if (document.hidden || navigator.onLine === false) { return; }
      return nativeCheck.apply(this, arguments);
    };
    lx.msg.freqRefresh = function (onload) {
      clearInterval(lx.msg.freqInterval);
      if (!onload) { activeUntil = Date.now() + 120000; }
      schedule(delay());
    };
    lx.msg.freqRefresh(true);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) { schedule(0); } });
    window.addEventListener('online', function () { schedule(0); });
    window.addEventListener('pagehide', function () { clearTimeout(timer); });
    window.addEventListener('pageshow', function () { schedule(0); });

    // Serialize sends and wait for a poll to finish before taking its cursor.
    // Never auto-retry a POST: a lost response may already have committed.
    var queue = [], pending = new Set(), sending = false;
    function feedback(form, message) {
      var status = form.querySelector('.lp-chat-feedback');
      if (!status) { status = document.createElement('p'); status.className = 'lp-chat-feedback'; status.setAttribute('role', 'status'); form.appendChild(status); }
      status.textContent = message; status.hidden = !message;
    }
    function busy(slot, value) {
      var form = slot.querySelector('.chatForm'), send = slot.querySelector('.lp-chat-send');
      form.setAttribute('aria-busy', String(value));
      if (send) { send.setAttribute('aria-disabled', String(value)); send.classList.toggle('is-disabled', value); }
    }
    function flush() {
      if (sending || !queue.length) { return; }
      if (lx.msg.refreshFetch || lx.msg.refreshHold) { setTimeout(flush, 100); return; }
      var job = queue.shift(), slot = document.getElementById('chat' + job.id);
      if (!slot || !slot.isConnected) { pending.delete(job.id); flush(); return; }
      var form = slot.querySelector('.chatForm'), field = slot.querySelector('textarea');
      if (navigator.onLine === false) {
        feedback(form, text.offline); busy(slot, false); pending.delete(job.id); flush(); return;
      }
      sending = true; lx.msg.refreshHold = true; feedback(form, text.sending);
      function finish() {
        sending = false; lx.msg.refreshHold = false; pending.delete(job.id); busy(slot, false); flush();
      }
      try {
        apex.server.process('chatAdd', {x01:job.id, x02:job.value, x03:slot.dataset.last}, {
          type:'POST', dataType:'json', timeout:30000,
          success:function (data) {
            if (!data.success) { feedback(form, data.err || text.failed); return; }
            if (field.value === job.value) { field.value = ''; }
            feedback(form, '');
            if (slot.isConnected) {
              lx.msg.chatAddMsgs(job.id, data.msgs || [], true);
              if (data.msgs && data.msgs.length && data.msgs[0].id) { slot.dataset.last = data.msgs[0].id; }
              lx.msg.attentionRemove(slot);
              var thread = slot.querySelector(':scope > .body > .cont'); if (thread) { thread.scrollTop = 0; }
            }
            lx.msg.topMenuRefresh(); lx.msg.freqRefresh();
          },
          error:function () { feedback(form, text.failed); },
          complete:finish
        });
      } catch (_) { feedback(form, text.failed); finish(); }
    }
    lx.msg.chatPost = function (id) {
      id = Number(id);
      var slot = document.getElementById('chat' + id);
      if (!slot || pending.has(id)) { return; }
      var field = slot.querySelector('textarea'), form = slot.querySelector('.chatForm');
      if (!field || !field.value.trim()) { return; }
      if (navigator.onLine === false) { feedback(form, text.offline); return; }
      pending.add(id); busy(slot, true); queue.push({id:id, value:field.value}); flush();
    };

    // P331 has no header picker host. Its native list and media panel stay intact.
    if (String(lx.msg.pg) === '331') {
      document.body.classList.add('lp-chat-page');
      var list = document.querySelector('.lxMsgList');
      var panel = document.querySelector('.MessagePanel');
      if (list && panel) {
        function decorateList() {
          var search = list.querySelector('.searchBox input');
          if (search) { search.setAttribute('aria-label', text.search); search.placeholder = text.search; }
          list.querySelectorAll('.msgListRow[onclick]').forEach(function (row) {
            var subject = row.querySelector('.subject'), people = row.querySelector('.recipients');
            if (subject) { subject.title = subject.textContent.trim(); }
            if (people && !people.querySelector('.lp-chat-recipient-names')) {
              var value = people.textContent.trim(), parts = value.split(/\s+\|\s+/);
              people.title = value;
              var names = document.createElement('span'); names.className = 'lp-chat-recipient-names';
              names.textContent = parts.length === 2 ? parts[0] : value;
              if (parts.length === 2) {
                var presence = document.createElement('span');
                presence.className = 'lp-chat-presence'; presence.textContent = parts[1];
                people.replaceChildren(names, presence);
              } else { people.replaceChildren(names); }
            }
            row.querySelectorAll('.n_time').forEach(function (meta) { meta.title = meta.textContent.trim(); });
            accessible(row, [subject && subject.textContent, people && people.title].filter(Boolean).join(' · '));
          });
        }
        new MutationObserver(decorateList).observe(list, {childList:true, subtree:true});
        decorateList();
        var back = document.createElement('button'); back.type = 'button'; back.className = 't-Button lp-chat-back';
        back.textContent = text.back; back.setAttribute('aria-expanded', 'false');
        back.addEventListener('click', function () {
          var open = document.body.classList.toggle('lp-chat-list-open'); back.setAttribute('aria-expanded', String(open));
        });
        panel.before(back);
        list.addEventListener('click', function (event) {
          var row = event.target.closest('.msgListRow');
          if (row) {
            list.querySelectorAll('.msgListRow').forEach(function (item) { item.classList.toggle('lp-chat-current', item === row); });
            document.body.classList.remove('lp-chat-list-open'); back.setAttribute('aria-expanded', 'false');
          }
        });
      }
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
